import { TitleError } from "./contentsettitle";
import { ConfirmPane, ConfirmPaneLockScroll } from "../../components/confirmpane";
import { useState } from "react";

export enum ContentSetActions{
    Delete='DELETE',
    Undo='UNDO',
    Save='SAVE'
}

export const ContentSetMenu=function(props:{showMenu:boolean, isLoggedIn:boolean, contentSetMenuClick:Function, titleError:TitleError, numItems:number, isContentSetNew:boolean}){
    const [showConfirmPane, setShowConfirmPane] = useState(false);
    
    if(props.showMenu===false)return null;

    const deleteClick=function(){
        if(props.isContentSetNew){
            props.contentSetMenuClick(ContentSetActions.Delete);
        }else{
            setShowConfirmPane(true);
            ConfirmPaneLockScroll(true);
        }
    }

    const deleteConfirmPaneClick=function(isConfirmed:boolean){
        ConfirmPaneLockScroll(false);
        setShowConfirmPane(false);
        if(isConfirmed)props.contentSetMenuClick(ContentSetActions.Delete);
    }

    let deleteText=props.isContentSetNew===true?"Discard":"Delete";

    let saveDisabled=false;
    if(props.numItems<5)saveDisabled=true;
    if(props.titleError!==TitleError.None)saveDisabled=true;
    if(props.isLoggedIn===false)saveDisabled=true;

    return(
			<div className='teachers-contentset-menu'>
            <button onClick={()=>{props.contentSetMenuClick(ContentSetActions.Save);}} className='teachers-button-light teachers-button' disabled={saveDisabled}>Save</button>
            <button onClick={deleteClick} className='teachers-button-light teachers-button'>{deleteText}</button>
            <ConfirmPane
                showConfirm={showConfirmPane}
                confirmClick={deleteConfirmPaneClick} 
                confirmMessage="Delete this set?" />
        </div> 
    )
};